import { tvpil } from '../compat/tvpil';
import { prefetchLastWatched } from '../lastWatched/prefetchLastWatched';
import { prefetchMostWatched } from '../mostWatched/prefetchMostWatched';

import { prefetchChannelCollection } from './prefetchChannelCollection';

type PrefetchChannelsArgs = {
  referenceId: string;
};

export function prefetchChannels({ referenceId }: PrefetchChannelsArgs) {
  if (!tvpil.userId) {
    return Promise.resolve();
  }

  return Promise.all([
    prefetchChannelCollection({ referenceId }),
    prefetchLastWatched(),
    prefetchMostWatched({ userId: tvpil.userId }),
  ]);
}
